module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Smart_Alarm.384d302c.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Smart_Alarm.svg
// module id = 3432
// module chunks = 0